import "./JobBoard.scss";

import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { JobInfo } from "../../../components/job/Job";
import { JobApiRoutes } from "../../../shared/api-routes/job/job-api.routes";
import http from "../../../shared/utils/http";
import JobsToolbar from "../components/jobs-toolbar/JobsToolbar";

const JobBoard: React.FC = () => {
	// const { isPremiumUserVisible } = useSelector((state: any) => state.Reducer);
	const location = useLocation();
	const [jobs, setJobs] = useState<JobInfo[]>([]);
	const [cursor, setCursor] = useState<string | null>(null);
	const [hasMore, setHasMore] = useState(true);
	const [loading, setLoading] = useState(false);
	const loaderRef = useRef<HTMLDivElement | null>(null);

	const onCreateJob = (jobInfo: JobInfo) => {
		setJobs((prev) => [jobInfo, ...prev]);
	};

	const onDeleteJob = (job_id: string) => {
		setJobs((prev) => prev.filter((item) => item.id !== job_id));
	};

	const loadMorePosts = async () => {
		if (loading || !hasMore) return;

		setLoading(true);
		const url = `${JobApiRoutes.GET_ALL_JOBS}?${
			cursor ? `&cursor=${cursor}` : ""
		}`;
		http.get(url).then((res) => {
			if (res.length === 0) {
				setHasMore(false);
			} else {
				setJobs((prev) => [...prev, ...res]);
				const lastJob = res[res.length - 1];
				setCursor(lastJob.createdAt);
			}
			setLoading(false);
		});
	};

	useEffect(() => {
		if (!loaderRef.current || !hasMore) return;

		const observer = new IntersectionObserver(
			(entries) => {
				if (entries[0].isIntersecting && !loading) {
					loadMorePosts();
				}
			},
			{
				rootMargin: "300px",
			}
		);

		observer.observe(loaderRef.current);

		return () => observer.disconnect();
	}, [loaderRef.current, hasMore, loading]);

	return (
		<div className="job-board-container">
			{/* <div className="trying-header" /> */}
			<JobsToolbar />
			<Outlet />
		</div>
	);
};

export default JobBoard;
